/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Company_Create_ButtonInputs */

const en_admin_create_company_create_button = /** @type {(inputs: Admin_Create_Company_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

const de_admin_create_company_create_button = /** @type {(inputs: Admin_Create_Company_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anlegen`)
};

/**
* | output |
* | --- |
* | "Create" |
*
* @param {Admin_Create_Company_Create_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_company_create_button = /** @type {((inputs?: Admin_Create_Company_Create_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Company_Create_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_company_create_button(inputs)
	return en_admin_create_company_create_button(inputs)
});